import { Map, List, fromJS } from 'immutable'
import { TYPE_PLACEHOLDER } from 'services/content-type'
import * as actions from './actions'

export const initialState = Map()

function _filterTilePlaceholder (article) {
  return article.get('type') !== TYPE_PLACEHOLDER
}

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.SET_TILES_ARTICLE_DATA:
      return state
        .set('data', fromJS(action.payload.data))
        .set('processing', action.payload.processing)
    case actions.APPEND_TILES_ARTICLE_DATA:
      // We should keep the current articles and remove any placeholders.
      return state.update(tilesArticleState => tilesArticleState
        .set('processing', action.payload.processing)
        .updateIn(['data', 'currentPage'], 0, () => action.payload.currentPage)
        .updateIn(['data', 'articles'], List(), (
          articles,
        ) => {
          if (action.payload.filterPlaceholders) {
            // eslint-disable-next-line no-param-reassign
            articles = articles.filter(_filterTilePlaceholder)
          }
          return articles.concat(fromJS(action.payload.articles))
        }))
    case actions.SET_TILES_ARTICLE_PROCESSING:
      return state.set('processing', action.payload)
    case actions.SET_TILES_ARTICLE_QUERY:
      return state
        .set('query', fromJS(action.payload.query))
        .set('processing', action.payload.processing)
    case actions.SET_TILES_ARTICLE_DATA_PLACEHOLDERS:
      return state.setIn(['data', 'articles'], fromJS(action.payload))
    case actions.APPEND_TILES_ARTICLE_DATA_PLACEHOLDERS:
      return state.updateIn(
        ['data', 'articles'],
        List(),
        articles => articles.concat(fromJS(action.payload)),
      )
    case actions.SET_TILES_ARTICLE_DATE_TIME_TEXT:
      return state.set('dateTimeText', action.payload)
    default:
      return state
  }
}
